import React, { FC } from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const IssueEdit = lazyLoader(
  () => import("Containers/Issue/IssueEdit/IssueEdit")
);

export const IssueEditPage: FC = () => {
  return (
    <Layout>
      <IssueEdit />
    </Layout>
  );
};
